import { Component, Prop, Vue } from 'vue-property-decorator';
import store from "Store/index"
import { OrderingListUserPermissionViewModel, OrderingListViewModel, OrderingListUserDetailViewModel, CreateUserPermissionCommand, OrderingListDetailsWithPermissionViewModel, RemoveUserPermissionCommand, UpdateUserPermissionCommand, UserHierarchyViewModel } from 'Api/CoreApi';
import Multiselect from 'vue-multiselect';
import BaseComponent from 'Components/Base/ABaseComponent';
import OrderingListUserMixin from 'Mixins/OrderingListUserMixin';
import { mixins } from 'vue-class-component';

export interface SelectModel{
    id: string;
    name: string;
    obj: UserHierarchyViewModel;
    $isDisabled: boolean;
}

@Component({
    template: "#ordering-list-user-permissions-template",
    components: {
        Multiselect
    }
})
export default class OrderingListUserPermissionsComponent extends mixins(BaseComponent,OrderingListUserMixin) {
    
    @Prop()
    public details: OrderingListUserDetailViewModel;
    
    //TOODO: not workin!!
    public selectedOrderingList: OrderingListViewModel = null;
    
    confirmDeleteElement: HTMLElement;

    public isSaving: boolean = false;
    public totalSavesLeft: number = 0;
    public totalSavesDone: number = 0;

    public canAdditemFromParentAll: boolean = false;
    public canRequestAddOfItemAll: boolean = false;
    public canExceedBudgetAll: boolean = false;
    public canViewBudgetAll: boolean = false;
    public canViewOrderHistoricAll: boolean = false;

    public async updateCanAdditemFromParentAll() {
        await this.updatePermissionsForAll("canAdditemFromParent", this.canAdditemFromParentAll, 2);
    }

    public async updateCanRequestAddOfItemAll() {
        await this.updatePermissionsForAll("canRequestAddOfItem", this.canRequestAddOfItemAll, 2);

    }

    public async updateCanExceedBudgetAll() {
        await this.updatePermissionsForAll("canExceedBudget", this.canExceedBudgetAll, 2);

    }

    public async updateCanViewBudgetAll() {
        await this.updatePermissionsForAll("canViewBudget", this.canViewBudgetAll, 2);
    }

    public async updateCanViewOrderHistoricAll() {
        await this.updatePermissionsForAll("canViewOrderHistoric", this.canViewOrderHistoricAll, 2);
    }

    public async updatePermissionsForAll(permissionName: string, permissionValue: boolean, chunkSize: number) {
        this.totalSavesLeft = this.details.orderingLists.length;
        this.totalSavesDone = 0;
        this.isSaving = true;

        const orderingLists = this.details.orderingLists;

        const updatePermissions = async (orderingList: any) => {
            orderingList.permissions[permissionName] = permissionValue;
            await this.update({}, orderingList.id);
            this.totalSavesDone += 1;
            // sleep for 100ms to avoid server overload
            //await new Promise((resolve) => setTimeout(resolve, 1000));
        };

        const chunks = [];

        for (let i = 0; i < orderingLists.length; i += chunkSize) {
            chunks.push(orderingLists.slice(i, i + chunkSize));
        }

        await Promise.all(chunks.map(async (chunk) => {
            await Promise.all(chunk.map(updatePermissions));
        }));

        this.isSaving = false;
    }



    //collapse (show/hide lists)
    public collapsed: boolean = true;
    
    async created(){     
        if(!this.isAdvancedAdmin) return;
                
        this.setLoading();
        await store.dispatch.orderingList.loadEmployeeOrderingLists();
        this.setLoaded();
    }
    
    
    async mounted(){
        this.confirmDeleteElement = document.getElementById('useradministration_confirm_delete_txt');
        this.collapsed = true;

        // Check head checkboxes
        if (this.details.orderingLists.every(x => x.permissions.canAdditemFromParent))
            this.canAdditemFromParentAll = true;

        if (this.details.orderingLists.every(x => x.permissions.canRequestAddOfItem))
            this.canRequestAddOfItemAll = true;

        if (this.details.orderingLists.every(x => x.permissions.canExceedBudget))
            this.canExceedBudgetAll = true;

        if (this.details.orderingLists.every(x => x.permissions.canViewBudget))
            this.canViewBudgetAll = true;

        if (this.details.orderingLists.every(x => x.permissions.canViewOrderHistoric))
            this.canViewOrderHistoricAll = true;
    }
    
    get orderingListsDetail(): OrderingListViewModel[]{
        if(this.orderingListsDetailFromStore)
        {
            
            return this.orderingListsDetailFromStore.filter(x => this.details.orderingLists.find(y => y.id == x.id) == null); 
        }
        return null;
    }
    
    get orderingListsDetailFromStore(){
        //TODO: filter away alread used lists.. server/client?..
        return store.state.orderingList.orderingLists;
    }
    
    
    
    async createPermission(){
        await store.dispatch.orderingListUser.createUserPermission(new CreateUserPermissionCommand({
            userIdentity : this.details.userIdentity,
            orderingListId : this.selectedOrderingList.id
        }));
    }
    
    async removePermission(listId: string){
        await store.dispatch.orderingListUser.removeUserPermission(new RemoveUserPermissionCommand({
            orderingListId: listId,
            userIdentity: this.details.userIdentity
        }));        
    }
    
    
    async update(event: any, listId: string) {        
        const orderingList = this.details.orderingLists.find(x => x.id == listId);
        
        
        await store.dispatch.orderingListUser.updateUserPermission(new UpdateUserPermissionCommand({
            orderingListId: listId,
            userIdentity : this.details.userIdentity,
            canAdditemFromParent : orderingList.permissions.canAdditemFromParent,
            canExceedBudget : orderingList.permissions.canExceedBudget,
            canRequestAddOfItem : orderingList.permissions.canRequestAddOfItem,     
            canViewBudget : orderingList.permissions.canViewBudget,
            canViewOrderHistoric : orderingList.permissions.canViewOrderHistoric
        }));
    }
    
    async removeUser(){
        var msg = this.confirmDeleteElement.innerHTML.replace('{0}', this.details.userIdentity);
        
        if(confirm(msg))
        {
            await store.dispatch.orderingListUser.removeUser(this.details.userIdentity);
        }
    }
    
    //selector
    get options(): any{
        if(this.orderingListsDetail){
            {
                const list = new Array<SelectModel>();
                for(let orderingListDetail of this.orderingListsDetail)
                {
                        var obj: SelectModel = {
                            id : orderingListDetail.id,
                            $isDisabled : false,
                            name : orderingListDetail.userHierarchy.customerNumber,
                            obj : orderingListDetail.userHierarchy
                        }
                        list.push(obj);
                }
                return list;
            }
        }
        return new Array<SelectModel>();
    }
    
    customLabel(model: SelectModel): string{
        if(model.$isDisabled){
            return `${this.customLabelForUser(model.obj)}`;
        }
        else{
            return `${model.obj.level} | ${this.customLabelForUser(model.obj)}`;
        }
    }
    
    
    customLabelForUser(obj: UserHierarchyViewModel): string {
        return `${obj.customerNumber.replace('-at-SHOP1','')} (${obj.companyName} : ${obj.customerAddress})`;
    }
    

    toggleCollapse(e: any){
        const self = this;
        let querySelectorAll = '[data-id="{0}"]'.replace('{0}', this.details.userIdentity);

        console.debug('debug: toggle collapse selector: '+querySelectorAll);
        document.querySelectorAll(querySelectorAll).forEach(x => {
            x.classList.toggle('in');
        });

        this.collapsed = !this.collapsed;
    }
    
}

Vue.component('ordering-list-user-permissions', OrderingListUserPermissionsComponent);